export enum ComparisonType {
  ALL = 'ALL',
  BANNER = 'BANNER',
  FIT_CATEGORY = 'FIT_CATEGORY'
}
